//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetCategoriesResponse } from './models/GetCategoriesResponse';
import { Utilities } from './Utilities';

export class CategoriesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAvailableCategories: (
			language?: string,
			includeSubcategories?: boolean,
        ): string => {
            let clientRequestUrl = '/api/v1/categories?';
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            if (includeSubcategories === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('includeSubcategories'));
            } else if (includeSubcategories !== undefined) {
                clientRequestUrl += `includeSubcategories=${encodeURIComponent(String(includeSubcategories))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get all available Categories for current user
     * @param language (optional) label language
     * @param includeSubcategories (optional) toggle to include subcategories
     * @return List of categories
     */
    async getAvailableCategories(
        language?: string,
        includeSubcategories?: boolean,
    ): Promise<GetCategoriesResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailableCategories(
            language,
            includeSubcategories,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetCategoriesResponse>(_response, false, []);
    }
}
